module.exports = __webpack_public_path__ + "static/media/fiskkit_tags.1858176a.jpg";